"use client";

import { ArrowRight, BookOpen, Gift, HandCoins } from "lucide-react";
import { useI18n } from "../../i18n/I18nProvider";
import { BASE_TRACKER_URL } from "../../utils/constants";
import { BetaBadge } from "../ui";

const PROFILE_ROUTES_MAP: Record<string, string> = {
  fr: "/profil",
  en: "/en/profile",
  es: "/es/perfil",
  "pt-br": "/pt-br/perfil-do-usuario",
};

const SignUpCard: React.FC<{ onClose: () => void }> = (props) => {
  const { t, lang } = useI18n();

  const onSignUpClick = () => {
    const selectedRoute = PROFILE_ROUTES_MAP[lang] ?? "/profil";
    window.location.href = `${selectedRoute}#register`;
  };

  return (
    <div className="flex flex-col justify-center items-center gap-8 pt-8">
      <img
        src={`${BASE_TRACKER_URL}/read2earn.svg`}
        alt="logo"
        className="w-36 h-12"
      />
      <div className="flex h-16 w-full justify-between items-center relative">
        <div className="flex justify-center items-center rounded-full w-16 h-16 border-3 border-white bg-white z-10">
          <BookOpen size={26} className="text-black"></BookOpen>
        </div>
        <div className="flex justify-center items-center rounded-full w-16 h-16 border-3 border-white bg-surface z-10">
          <HandCoins size={26} className="text-white"></HandCoins>
        </div>
        <div className="flex justify-center items-center rounded-full w-16 h-16 border-3 border-white bg-surface z-10">
          <Gift size={26} className="text-white"></Gift>
        </div>
        <div className="absolute -left-4 h-1 bg-white w-full"></div>
      </div>
      <p className="text-gray-300 text-center px-10 m-0">
        {t("NotConnectedDescription")}
      </p>
      <button
        onClick={onSignUpClick}
        className="flex justify-center items-center px-3 py-2 w-full font-bold text-white bg-primary transition-colors hover:bg-orange-700 rounded-xl"
        style={{ cursor: "pointer" }}
      >
        {t("SignUp")}
        <ArrowRight className="ml-2" size={18} />
      </button>
      <BetaBadge />
    </div>
  );
};

export default SignUpCard;
